/*
 * @Author: cc
 * @LastEditTime: 2022-06-17 17:21:06
 */
import { useEffect, useState } from "react";
// import { IsPc } from "../utils/index";
import Style from "./index.module.scss"
import "moment/locale/zh-cn";
import { useLocation, useHistory } from "react-router-dom";
// import {get} from "../component/fetch"
// import store from '../../reducers/index'
// import logo from "../../img/logo.png"
// import Login from "../component/login"
// import SignUp from "../component/signupModal";
import { post, get } from "../../component/fetch"
import { Button, Popup, Space, Tabs, Toast, Modal } from 'antd-mobile';
import store from '../../reducers/index'
import { connect } from "react-redux"
import { FileOutline, RightOutline } from "antd-mobile-icons"
import Subscription from "./component/subscription";
import { isInApp, isWechat } from "src/utils/web-call-app";
import QRCode from "qrcode.react";
import { encode } from "querystring";
import { wx_share,useQuery } from "src/utils";
import subscript_logo from "src/img/subscript_logo.png"
import VConsole from 'vconsole';

const { BASE_URL, PUBLIC_URL } = process.env
export interface Category {
  zhName: string;
  enName: string;
  required: boolean;
  fieldType: string;
  tips?: string;
  placeholder?: string;
  selectOptions: string[];
  id: number;
}
const Index = (props: any) => {
  const query = useQuery()
  const history = useHistory();
  // let query = new URLSearchParams(window.atob(window.location.pathname.split('/')[1]));
  // console.log(params.get('watchType'))
  const columnId = query.get('columnId') || ''
  const subjectId = query.get('subjectId') || ''
  const openId = query.get('openId') || ''
  // const [loginView, setLoginView] = useState(false)
  // const [signupView, setSignView] = useState(false)
  const watchType = query.get('watchType') || ''
  const [list, setList] = useState([{ id: 0, name: '第一期' }])
  const [subscriptionModal, setSubscriptionModal] = useState(false)
  const userInfo: any = store.getState().userInfo
  // const columnInfo:any = store.getState().InitPageData
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const jump = (item: any) => {
    history.push(`/project?columnId=${columnId}&subjectId=${item.id}`)
  }
  function UrlQRCode({ url }: any) {
    return <QRCode value={url} />;
  }
  // const SignUpClick = () => {
  //   const userInfo: any = store.getState().userInfo
  //   if (!userInfo.userId) {
  //       Toast.show({
  //       icon: 'success',
  //       content: '保存成功',
  //     })
  //   } else {
  //     setSignView(true)
  //   }
  // }
  // const getUserInfo = () => {
  //   post('/shop/front/userInfo', {}, false).then(res => {
  //     store.dispatch({
  //       type: "SET_USER_INFO",
  //       ...res.data
  //     })
  //   })
  // }
  // const getColumnDetail = () => {
  //   get('/shop/front/ge/column/subject/getDetail2?subjectId=' + subjectId + (watchType ? '&watchType='+ watchType : ''), {}, false).then(res => {
  //     setColumnInfo(res.data)
  //   })
  // }
  const getThemList = () => {
    post('/shop/front/ge/column/subject/getList', { columnId }, false).then(res => {
      setList(res.data.list)
    })
  }
  const sunScriptionFun = () => {
    if (!userInfo.userId) {
      Toast.show({
        content: "请重新登录"
      })
      history.push(`/login?columnId=${columnId}&subjectId=${subjectId}`)
      return
    }
    if (isInApp()) {
      // let humanId = ''
      get(`/shop/front/ge/column/sub/${columnId}/2`, {}, false).then((res: any) => {
        if (res.data.code === 0) {
          Toast.show({
            icon: 'success',
            content: res.data.msg,
          })
        }
      })
    }
    else if (isWechat()) {
      wechatSubscript()
    } else {
      Modal.alert({
        title: "订阅通知",
        content:
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <p>打开微信“扫一扫”，使用微信完成订阅</p>
            <UrlQRCode url={props.columnInfo?.mobileWatchUrl} />
          </div>
        ,
        onConfirm: () => {
          console.log('Confirmed')
        },
      })
    }
  }
  const wechatSubscript = () => {
    if (openId) {
      post('/shop/front/ge/column/sendWeChatSubMsgOnlyOneTime', { openId, templateId: 'fVa38a33JydSf8Q8EecfiWIKJQm9MhhoY7HnYpfYRZY', scene: '1002' }, false)
      post('/shop/front/ge/column/sub', { columnId, subType: 1 }, false).then(res => {
        Toast.show({
          icon: 'success',
          content: res.msg,
          duration: 1000,
        })
        window.location.href = BASE_URL + `/#/?columnId=${columnId}&subjectId=${subjectId}`
      })
    } else {
      let url = encodeURIComponent(`https://school.mvwchina.com/graduation/#/?columnId=${columnId}&subjectId=${subjectId}`)
      window.location.href = `https://mp.weixin.qq.com/mp/subscribemsg?action=get_confirm&appid=wx3d12a4d640647d46&scene=1002&template_id=fVa38a33JydSf8Q8EecfiWIKJQm9MhhoY7HnYpfYRZY&redirect_url=${url}#wechat_redirect`
    }
  }
  function getColumnDetail() {
    get('/shop/front/ge/getColumnDetail?columnId=' + columnId + '&subjectId=' + subjectId + (watchType ? '&watchType=' + watchType : ''), {}, false).then((res: any) => {
      store.dispatch({
        type: "SET_INIT_PAGE_INFO",
        ...res.data
      })
      document.title = res.data.titleName
      if (isWechat()) {
        wx_share('分享给你一堂好课', res.data.titleName, window.location.href.split('#')[0], res.data.logoUrl)
      }
    })
  }
  useEffect(() => {
    if (isWechat()) {
      const script = document.createElement('script');
      script.src = 'http://res2.wx.qq.com/open/js/jweixin-1.6.0.js';
      // script.async = true;
      script.onload = () => {
        post('/shop/front/ge/column/getWechatJsApiSignature', { appId: "wx3d12a4d640647d46", url: window.location.href.split('#')[0] }, false).then(res => {
          window.wx.config({
            debug: false,
            appId: 'wx3d12a4d640647d46',
            timestamp: res.data.timestamp, // 填入生成签名的时间戳
            nonceStr: res.data.nonceStr, // 填入生成签名的随机串
            signature: res.data.signature, // 填入签名
            jsApiList: ['updateAppMessageShareData'] // 需要使用的微信 JS SDK 接口列表
          });
          window.wx.error(function (res: any) {
            console.error('微信 JS SDK 初始化失败:', res);
          });
        })
      };
      document.body.appendChild(script);
    }
    getColumnDetail()
    getThemList()
  }, [])
  return (
    <div className={Style.mobileHome}>
      <div className={Style.banner}>
        <img src={props.columnInfo ? props.columnInfo.logoUrl : ''} alt="" />
        {/* <AutoCenter className={Style.title}>{props.columnInfo.titleName}</AutoCenter> */}
      </div>
      <div className={Style.content}>
        <Tabs>
          <Tabs.Tab title='介绍' key='fruits'>
            <h2 className="ptb80" style={{ fontWeight: "bolder" }}>{props.columnInfo.titleName}</h2>
            <p className="c-bg-fff plr40 ptb40 radios12" onClick={() => setSubscriptionModal(true)}><FileOutline className="mr40" /> 课程更新 订阅提醒 <span className="fr"><RightOutline /></span></p>
           { props.columnInfo.trainFileUrl&& <p className="c-bg-fff plr40 ptb40 radios12" onClick={() => history.push('/pdf?trainFileLongUrl='+props.columnInfo.trainFileLongUrl)}><FileOutline className="mr40" /> 培训通知<span className="fr"><RightOutline /></span></p>}
            <div className="c-bg-fff  plr40 ptb40 radios12" dangerouslySetInnerHTML={{ __html: props.columnInfo.content }}>
            </div>
          </Tabs.Tab>
          <Tabs.Tab title='目录' key='vegetables'>
            <h2 className="ptb80" style={{ fontWeight: "bolder" }}>{props.columnInfo.titleName}</h2>
            <p className="c-bg-fff plr40 ptb40 radios12" onClick={() => setSubscriptionModal(true)}><FileOutline className="mr40" /> 课程更新 订阅提醒 <span className="fr"><RightOutline /></span></p>
            <div className="c-bg-fff plr40 ptb40 radios12">
              {list.length > 0 && list.map((item: any, index: number) => {
                return <div className={`${Style.listItem} pos-r`} key={index} onClick={() => jump(item)}>
                  {/* <span className={Style.orderNum}>NO.{item.orderNum}期</span> */}
                  <span className={`${Style.status} ${item.runStatus === '进行中' ? Style.finish : Style.cancel}`}>{item.runStatus}</span>
                  <img src={item.logoUrl} alt=""></img>
                </div>
              })}
            </div>
          </Tabs.Tab>
        </Tabs>
        <Popup
          visible={subscriptionModal}
          onMaskClick={() => {
            setSubscriptionModal(false)
          }}
          bodyStyle={{
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            minHeight: '40vh',
          }}
        >
          <div className={Style.subscriptionModal}>
            <img src={subscript_logo} alt=""></img>
            <p className="mt40">订阅授权</p>
            <p className="tc mt40 c-999">为了您能及时了解课程更新情况，电子书包服务号希望可以给您推送消息</p>
            <div className="flex justify-between w100 plr40 pos-a" style={{ bottom: "20px" }}>
              {/* <Subscription onCancel={()=>setSubscriptionModal(false)}/> */}
              <Button className={`${Style.btn}`} onClick={() => setSubscriptionModal(false)}>取消</Button>
              <Button type="primary" className={`${Style.btnYellow} ${Style.btn}`} onClick={sunScriptionFun}>授权订阅</Button>
            </div>
          </div>
        </Popup>
        {/**
         *    {list&&list.length>0&&<div className="c-999"><AppstoreOutline /> 往期主题</div>}
        <div className={Style.item_content}>         
          {list.map((item: any, index: number) => {
            return <div className={Style.list_item} key={index} onClick={() => jump(item)}>
                <img src={item.logoUrl} alt=""></img>
              </div>
          })}
        </div>
      
         */
        }

      </div>
      {/* <div className={Style.footer}>
        <Button className={Style.myBtns} onClick={()=>{history.push(`/project?columnId=${columnId}&subjectId=${subjectId}`)}}>立即观看</Button>
      </div> */}
    </div>
  );
};
const mapStateToProps = (state: any) => ({
  columnInfo: state.InitPageData, // 映射仓库中的某个变量到组件的props
});
export default connect(mapStateToProps)(Index);
